import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { AccessPipe } from '../../pipes/access.pipe';

@Component({
    selector: 'app-bulk-changes',
    templateUrl: './bulk-changes.component.html',
    styleUrls: ['./bulk-changes.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BulkChangesComponent implements OnInit {

  @Input() selected: any[];
  @Input() data: any = null;
  @Input() project: any = null;

	@Output() onClose = new EventEmitter<any>();
	@Output() onActionBulk = new EventEmitter<any>();

  maxWidth: any = null;

	close() {
		this.onClose.emit();
	}

  bulkAction(opt) {
    this.onActionBulk.emit(opt);
  }

  calcWidth() {
    this.data.options = this.data.options.map(opt => {
      if (opt.idAccess) {
        if (this._aP.transform({id: opt.idAccess, type:'write'})) return opt;
      }
      else return opt;
    }); 
    this.maxWidth = (this.data.options.length * 67) + 90; 
  }

	constructor(
    private _aP: AccessPipe
  ) { }

	ngOnInit(): void {
    this.calcWidth();
	}
}
